import { markRaw } from 'vue';

import { SalePointsWithTerminalsFragment } from '@/app/graphql/sale-point/sdk.sale-point';

export interface PosStatementForm {
  salePoint: SalePointsWithTerminalsFragment | null;
  posNumbers: string[];
  startDate: string | null;
  endDate: string | null;
  isAllPosAndKiosks: boolean;
  isFilterByTransactionDate: boolean;
}

export const POS_STATEMENT_ALL_SALE_POINTS_OPTION = 'DOCUMENTS.STATEMENT_ACCOUNT.OUTLET.SELECT_ALL_OUTLET';
export const POS_STATEMENT_ALL_POS_OPTION = 'DOCUMENTS.STATEMENT_ACCOUNT.OUTLET.SELECT_ALL_POS';
export const POS_STATEMENT_ALL_POS_AND_KIOSKS_OPTION = 'DOCUMENTS.STATEMENT_ACCOUNT.OUTLET.SELECT_ALL_POS_AND_KIOSKS';
export const ALL_POS_AND_KIOSKS_PARTY_ID = 618836;
export const ALL_POS_AND_KIOSKS_QR_SERVICE_ID = '400';

export const ALL_SALE_POINTS_OPTION: SalePointsWithTerminalsFragment = markRaw({
  name: POS_STATEMENT_ALL_SALE_POINTS_OPTION,
  code: 0,
  address: null,
  terminalCodes: [],
});

export const INITIAL_ACCOUNT_STATEMENT_FORM: PosStatementForm = {
  salePoint: null,
  posNumbers: [],
  startDate: null,
  endDate: null,
  isAllPosAndKiosks: false,
  isFilterByTransactionDate: false,
};

export const shouldAddAllPosAndKiosksOption = (
  partyId: number | null | undefined,
  salePoint: SalePointsWithTerminalsFragment | null
) => partyId === ALL_POS_AND_KIOSKS_PARTY_ID && Boolean(salePoint);

const shouldExpandAllPosNumbers = (posNumbers: string[]) =>
  posNumbers.length === 1 &&
  (posNumbers[0] === POS_STATEMENT_ALL_POS_OPTION || posNumbers[0] === POS_STATEMENT_ALL_POS_AND_KIOSKS_OPTION);

export const resolvePosNumbersForStatement = (posNumbers: string[], availablePosNumbers: string[]) =>
  shouldExpandAllPosNumbers(posNumbers) ? [...availablePosNumbers] : posNumbers;
